import * as React from "react"
import { Box } from "@mui/material"

import { ellipsisStyle } from "@utils"


export default function SkuLabel({label, ellipsis=true, maxWidth=120, sx={}}) {

    return <Box
        component="span"
        title={ellipsis ? label : null}
        sx={{
            display: "inline-block",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            ...sx,
            ...ellipsis && ellipsisStyle(maxWidth)
        }}
    >
        {label}
    </Box>
}